// @flow
import { NOTAM_DETAILS_DIALOG_TOGGLE } from 'actions/notamDetailsDialog';

const INITIAL_STATE = {
  visible: false,
};

export default function reduce(state = INITIAL_STATE, { type, visible }) {
  switch (type) {
    case NOTAM_DETAILS_DIALOG_TOGGLE:
      return {
        ...state,
        visible,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/notamDetailsDialog.js